export default class ImageConverter {
  static AddConfigStringBeforeImageDataString(
    imageSRC: string,
    imageType: string
  ): string {
    return "data:" + imageType + ";base64," + imageSRC;
  }
}
